import blakePic from "@/public/images/artists/blake.png";
import { Artist } from "@/types/types";

export const blake = {
  id: "104",
  name: "Blake",
  image: blakePic,
  description: `Blake is a force to be reckoned with, wielding a raspy voice that paints his music with raw emotion and untamed energy.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fblake-preview.mp3",
  meta: {
    free: true,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Rock", "Gritty", "Belting"],
      secondary: ["Singer", "Power"],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Mid",
      },
      specific: {
        low: 51,
        high: 68,
      },
    },
  },
} as const satisfies Artist;
